export default function(_) {
  return _ == null || _ === '' ? null : +_;
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-util/src/toNumber.js
// module id = 876
// module chunks = 0